
    module.exports = {
      render: function(){with(this){return _c('page-404')}},
      staticRenderFns: []
    };
  